export const message = 'Check your email in few minutes for a link to download the data.';
